import React, {useState, useEffect} from 'react'
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Loader from '../components/Loader'
import AppearAnimation from '../components/AppearAnimation';
import CookieBanner from '../components/CookieBanner'
import { Helmet } from 'react-helmet-async'

function StartScreen() {
  const [loading, setLoading] = useState(true);
  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 3000)
  },[]);

  useEffect(() => {
    setTimeout(() => {
      setShowBtn(true)
    }, 10000)
  },[]);

  return (
  <div> 
    <Helmet>
      <title>RayquazaITA – Carte Pokémon TCG Pocket </title>
      <meta name="description" content="RayquazaITA: carte digitali Pokémon TCG Pocket, Full-Art e rarità Rainbow/SAR, consegna rapida e sicura." />
    </Helmet>

    <CookieBanner/>
    
    {loading ? (
      <Loader />
    ) : (
  <div> 
    <AppearAnimation>
    

    <div className="background-video">
        <video id="desktop-video" autoPlay loop muted poster="/static/images/RayquazaPC_poster.jpg">
          <source src="/static/images/RayquazaPC.mp4" type="video/mp4" />
          {/* Altre versioni o formati del video desktop */}
        </video>
        <video id="mobile-video" autoPlay loop muted poster="/static/images/RayquazaPhone_poster.jpg">
          <source src="/static/images/RayquazaPhone.mp4" type="video/mp4" />
          {/* Altre versioni o formati del video mobile */}
        </video>
      </div>

    </AppearAnimation>
    </div>
    )}

{showBtn ? (
  <AppearAnimation>
      <div className='center'>
      <a href='/home'>
      <Button id='center-button' type='submit' variant='black'>Accedi alla home del sito🐉</Button>
      </a>
      </div>
  </AppearAnimation>
    ) : ( <></>)}
    
    </div>
  )
}

export default StartScreen